import { GraphQLFormattedError } from 'graphql';

export enum CLAIM_ACCOUNT_STEP {
  SELECT_COUNTRY,
  LOGIN,
  FORGOT_PASSWORD,
  ACCOUNT_EMAIL_CONFIRM,
}

export type ModalProps = {
  isOpen: boolean;
  close: () => void;
  setSelectedDivisionId?: (id: number) => void;
  handleDivisionChange?: (id: number) => void;
};

export type ModalStepProps = {
  step: CLAIM_ACCOUNT_STEP;
  setStep: (step: CLAIM_ACCOUNT_STEP) => void;
};

export type Instance = {
  instance: Record<string, any>;
  setInstance: (instance: Record<string, any>) => void;
};

export interface Error extends GraphQLFormattedError {
  data: {
    errorData?: {
      onboardingStatus?: string;
      status?: string;
      token?: string;
      instance?: string;
    };
    errorCode?: number;
  };
}
